import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Achievements } from '../../../../types/globalTypes';
import { Box, Title, VerticalBox } from '../../../../components';
import { AchElement } from './AchievementElement';
import { useTranslation } from 'react-i18next';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  achievements: Achievements[];
}

export const ProjectAchievements: React.FC<DivProps> = ({
  achievements,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <SectionContainer $color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <VerticalBox>
          <SectionTextContainer $gap={80}>
            <Title title={t('screen.project.achievements')} isAnimated={true} />
            <AchievementsContainer {...props}>
              {achievements.map((ach, index) => (
                <AchElement key={index} txt={ach.Description} />
              ))}
            </AchievementsContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const AchievementsContainer = styled(MotionYOffsetBlock)`
  max-width: 1400px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 84px;
  row-gap: 48px;
  @media screen and (${device.md}) {
    gap: 48px;
  }
  @media screen and (${device.sm}) {
    gap: 20px;
    h4 {
      font-size: 14px;
      line-height: 18px;
    }
  }
  @media screen and (${device.xs}) {
    grid-template-columns: 1fr;
    gap: 48px;
    > div {
      padding-top: 5px;
    }
  }
`;
